import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../Style/Blog.css'
import axios from 'axios'
import Blogs1_Icon from '../Blogs_Icons/Untitled-2-1200x700-c-default.png'
import Blogs2_Icon from '../Blogs_Icons/blog_resized_900_450_49_1639295414_types_ceiling_lamps (1).jpg'
import Blogs3_Icon from '../Blogs_Icons/18-11-97-1200x700-c-default.png'

function Blog_Section() {
    const [Blog1_title, SetBlogs1_title] = useState()
    const [Blog1_main_description, SetBlogs1_main_description] = useState()
    const [Blog1_link, SetBlogs1link] = useState()
    const [Blog1_Thumbnail, setBlog1Thumbnail] = useState()


    const [Blog2_title, SetBlogs2_title] = useState()
    const [Blog2_main_description, SetBlogs2_main_description] = useState()
    const [Blog2_link, SetBlogs2link] = useState()
    const [Blog2_Thumbnail, setBlog2Thumbnail] = useState()

    const [Blog3_title, SetBlogs3_title] = useState()
    const [Blog3_main_description, SetBlogs3_main_description] = useState()
    const [Blog3_link, SetBlogs3link] = useState()
    const [Blog3_Thumbnail, setBlog3Thumbnail] = useState()

    useEffect(() => {
        axios.post("http://127.0.0.1:3001/blogs")
        .then(data => {
            SetBlogs1_title(data.data[0].title)
            SetBlogs1_main_description(data.data[0].main_description)
            SetBlogs1link(data.data[0].link)
            setBlog1Thumbnail(data.data[0].thumbnail)

            SetBlogs2_title(data.data[1].title)
            SetBlogs2_main_description(data.data[1].main_description)
            SetBlogs2link(data.data[1].link)
            setBlog2Thumbnail(data.data[1].thumbnail)

            SetBlogs3_title(data.data[2].title)
            SetBlogs3_main_description(data.data[2].main_description)
            SetBlogs3link(data.data[2].link)
            setBlog3Thumbnail(data.data[2].thumbnail)
        })
        .catch(err => console.log(err))
    })
    return (
        <>
            {/* maximum descrioption : 105 */}
            <div className='blog-section'>
                <div className='title'>بلاگ</div>
                <div className='blog-list'>
                    <Link to={Blog1_link} className='blog-card'>
                        <div className='blog-image'>
                            <img alt='blog-image' src={require(`../Blogs_Icons/${Blog1_Thumbnail? Blog1_Thumbnail: "blog_resized_900_450_49_1639295414_types_ceiling_lamps (1).jpg"}`)} />
                        </div>
                        <div className='blog-title'>{Blog1_title}</div>
                        <div className='blog-description'>{Blog1_main_description}...</div>
                        <Link to={Blog1_link} className='blog-read-more'>ادامه...</Link>
                    </Link>
                    <Link to={ Blog2_link} className='blog-card'>
                        <div className='blog-image'>
                            <img alt='blog-image' src={require(`../Blogs_Icons/${Blog2_Thumbnail? Blog2_Thumbnail: "blog_resized_900_450_49_1639295414_types_ceiling_lamps (1).jpg"}`)} />
                        </div>
                        <div className='blog-title'>{Blog2_title}</div>
                        <div className='blog-description'>{Blog2_main_description}...</div>
                        <Link to={ Blog2_link} className='blog-read-more'>ادامه...</Link>
                    </Link>
                    <Link to={Blog3_link} className='blog-card'>
                        <div className='blog-image'>
                            <img alt='blog-image' src={require(`../Blogs_Icons/${Blog3_Thumbnail? Blog3_Thumbnail: "blog_resized_900_450_49_1639295414_types_ceiling_lamps (1).jpg"}`)} />
                        </div>
                        <div className='blog-title'>{Blog3_title}</div>
                        <div className='blog-description'>{Blog3_main_description}...</div>
                        <Link to={Blog3_link} className='blog-read-more'>ادامه...</Link>
                    </Link>
                </div>
                <Link to={"/blogs"} className='read-more-blogs-button'>مطالب بیشتر</Link>
            </div>
        </>
    )
}

export default Blog_Section